<template>
    <div class="form-page">
        <my-form v-model="form" @submit="submitHandler" table>
            <my-form-item-group title="添加中标结果通知书">
                <el-form-item label="标段名称" prop="bdcode"  :rules="newRule('标段名称', 'required','change')">
                    <my-select :data="bdlist" v-model="form.bdcode" placeholder="请选择标段名称" :props="{value:'bdcode',label:'bdname'}" @select="gethxr" style="width:50%;"></my-select>
                    <el-button 
                        icon="el-icon-circle-check" 
                        type="primary" 
                        v-if="type=='xt'||type=='zc'"
                        @click="tzsmb()">
                            点击生成该标段通知书word
                    </el-button>  
                </el-form-item>
                <el-form-item label="通知书编号" prop="tzscode"  :rules="newRule('通知书编号', 'required')">
                    <el-input type="text" v-model="form.tzscode"  disabled></el-input>
                </el-form-item>
                <el-form-item label="通知书类型" prop="typecode"  :rules="newRule('通知书类型', 'required','change')">
                    <my-select :data="tzstype" v-model="form.typecode" @select="settzs" placeholder="请选择通知书类型" :props="{value:'diccode',label:'dicname'}" style="width:100%;"></my-select>     
                </el-form-item>
                <el-form-item label="中标人/未中标人" prop="aa"  :rules="newRule('中标人/未中标人', 'required')">
                    <my-select v-if="isdx" ref="multiSelect" :collapse-tags="true" key="isdxMul" multiple :data="zbhxrlist" @remove-tag="deleteTag" v-model="form.aa" :cs="'ts'" @select="gethxrxx" placeholder="请选择中标人/未中标人" :props="{value:'hxrdwcode',label:'hxrdwname'}" style="width:100%;"></my-select>

                    <my-select v-else key="isdxSingle" :data="zbhxrlist" @remove-tag="deleteTag" v-model="form.aa" :cs="'ts'" @select="gethxrxx" placeholder="请选择中标人/未中标人" :props="{value:'hxrdwcode',label:'hxrdwname'}" style="width:100%;"></my-select>

                    <my-tag  type="danger">注意：选择候选人之前必须先选择标段</my-tag>
                </el-form-item>

                <el-form-item v-if="form.domains.length > 0" v-for="(domain, index) in form.domains" :label="domain.dwname" :rules="newRule('报价数据', 'required')" class="table-full-row">
                    <span style="margin-right: 5px; width: 6%;">报价类型：</span>
                    <my-select :data="bjtypelist" v-model="domain.bjlx" placeholder="请选择报价类型" :props="{value:'diccode',label:'dicname'}"  style="width:15%;"></my-select>
                    <span style="margin-right: 5px; margin-left: 5px; width: 6%;">中标/投标价格：</span>
                    <el-input type="text" v-model="domain.zbjg" @blur="((value)=>{bzyzs(value, index)})" placeholder="请输入价格" v-if="domain.bjlx==='1'" style="width:30%"></el-input>
                    <span v-if="domain.jgshow" class="active oneposi">请输入价格</span>
                    <el-input type="text" v-model="domain.zbbj" @blur="((value)=>{yzs(value, index)})" placeholder="请输入价格" v-if="domain.bjlx!=='1'" style="width:30%"></el-input>
                    <span v-if="domain.jgshow" class="active oneposi">请输入价格</span>
                    <my-select :data="jgdw" v-model="domain.jgdwcode" @select="((value)=>{bzyzs(value, index)})" v-if="domain.bjlx==='1'" placeholder="请选择价格单位" :props="{value:'diccode',label:'dicname'}"  style="width:15%;"></my-select>
                    <span v-if="domain.dwshow" class="active twoposi">请选择价格单位</span>
                    <my-select :data="bztype" v-model="domain.bzcode" @select="((value)=>{yzs(value, index)})" v-if="domain.bjlx==='1'" placeholder="请选择币种" :props="{value:'diccode',label:'dicname'}"  style="width:15%;"></my-select>
                    <span v-if="domain.bzshow" class="active thereposi">请选择币种</span>
                </el-form-item>

                <el-form-item label="通知书文本" prop="tzscontent"  :rules="newRule('通知书文本', 'required')" class="table-full-row">
                    <ueditor v-model="form.tzscontent" />
                </el-form-item>
                <el-form-item label="附件" class="table-full-row">
                    <template v-if="type=='zc'||type=='xt'">
                        <my-tag type="danger">请上传盖章后的的中标通知书/中标结果通知书扫描件！</my-tag>
                    </template>
             
                    <my-upload :file-guid="form.fileguid|| ''" file-type="jpg、zip、rar"  :file-size="15"></my-upload>
                </el-form-item>
            </my-form-item-group>
            <template slot="btn" class="btn" slot-scope="scope">
                <el-button icon="el-icon-circle-check" type="primary" @click="fSave('1',scope.submitHandler)">
                    提交
                </el-button>
                <el-button icon="el-icon-remove-outline" type="warning" @click="fSave('0',scope.submitHandler)">
                    暂存
                </el-button>    
            </template>
        </my-form>

        <!-- 弹窗 -->
        <my-dialog 
            :showclose="false"
            v-model="dialogVisible" 
            :title="dialogTitle">
                <component 
                    v-if="dialogVisible" 
                    :is="dialogComponent" 
                    :data="dialogData" 
                    @cancle="dialogClose">
                </component>
        </my-dialog>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from "@views/mixins/form-page";

import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'
export default {
    mixins: [FORM_PAGE_MIXIN,DIALOG_LIST_PAGE_MIXIN],
    components: {
        ChoiceContent:() => import('./components/choice-content'),
    },
    data() {
        return{
            jgshow:false,
            dwshow:false,
            bzshow:false,
            bjtypelist:[
                {dicname:'金额',diccode:'1'},
                {dicname:'费率/比率/优惠率/合格率等',diccode:'2'},
                {dicname:'单价',diccode:'3'},
                {dicname:'其他形式',diccode:'4'},
            ],
            form:{
                shbj:'',
                bdcode:'',
                bdname:'',
                fileguid:'',
                bjlx:'',
                typename:'',
                typecode:'',
                tzscode:'',
                zbdwname:'',
                jgdwname:'',
                bzname:'',
                domains: [],
                aa: '',
            },
            pgData:{
                procode:'',
                sortname:'yccode',
                pageindex:'1',
                sortorder:'desc',
                pagesize:'20'
            },
            bdlist:[],
            zbhxrlist:[],
            jgdw:[],
            bztype:[],
            tzstype:[],
            type:'',
            isdx:false,
            selectCount:0,
            domainlist:'',

            b:{},//初始化储存变量

            // dialog
            dialogComponent: '',
            dialogData: {},
            dialogTitle:'',

            nodekey:''
            
        }
    },
    computed: {

    },
    watch: {
        isdx:function(value){
            if(value){
                this.form.aa = [];
            }else{
                this.form.aa = '';
            }
        }
    },
    methods: {
        //验证
        yzs:function(data, index){
            if(data){
                this.form.bzname=data.dicname;
                this.form.domains[index].bzname=data.dicname;
            }
            this.jgyzindex(index);
        },
        bzyzs:function(data, index){
            if(data){
                this.form.jgdwname=data.dicname;
                this.form.domains[index].jgdwname=data.dicname;
            }
            this.jgyzindex(index);
        },
        // 单个校验
        jgyz:function () {
            if(this.form.bjlx!=='1'){
                if(this.form.zbbj===''||this.form.zbbj===undefined||this.form.zbbj===null){
                    this.jgshow=true
                }else{
                    this.jgshow=false;
                }
            }else{
                if(this.form.zbjg===''||this.form.zbjg===undefined||this.form.zbjg===null){
                    this.jgshow=true;
                }else{
                    this.jgshow=false;
                }
                if(this.form.jgdwcode===''||this.form.jgdwcode===undefined||this.form.jgdwcode===null){
                    this.dwshow=true;
                }else{
                    this.dwshow=false;
                }
                if(this.form.bzcode===''||this.form.bzcode===undefined||this.form.bzcode===null){
                    this.bzshow=true;
                }else{
                    this.bzshow=false;
                }
            }
        },
        jgyzindex:function (index) {
            if(this.form.domains[index].bjlx!=='1'){
                if(this.form.domains[index].zbbj===''||this.form.domains[index].zbbj===undefined||this.form.domains[index].zbbj===null){
                    this.form.domains[index].jgshow=true
                }else{
                    this.form.domains[index].jgshow=false;
                }
            }else{
                if(this.form.domains[index].zbjg===''||this.form.domains[index].zbjg===undefined||this.form.domains[index].zbjg===null){
                    this.form.domains[index].jgshow=true;
                }else{
                    this.form.domains[index].jgshow=false;
                }
                if(this.form.domains[index].jgdwcode===''||this.form.domains[index].jgdwcode===undefined||this.form.domains[index].jgdwcode===null){
                    this.form.domains[index].dwshow=true;
                }else{
                    this.form.domains[index].dwshow=false;
                }
                if(this.form.domains[index].bzcode===''||this.form.domains[index].bzcode===undefined||this.form.domains[index].bzcode===null){
                    this.form.domains[index].bzshow=true;
                }else{
                    this.form.domains[index].bzshow=false;
                }
            }
        },
        //生成通知书
        tzsmb:function(){
            if(this.form.bdcode===''||this.form.bdcode===null||this.form.bdcode===undefined){
                ShowMsgBox('请先选择标段')
            }else{
                window.open("/mb/zbjgtzs.do?bdcode="+this.form.bdcode)
            }
        },
        //获取候选人
        gethxr:function(data, status){
            var that = this;
            if(status!=1){
                that.isdx = false;
                that.form.aa = '';
                that.form.domains = [];
                that.form.typecode = '';
                that.form.typename = '';
            }
            
            this.form.bdname=data.bdname;
            that.$post(`${this.getGetters('bidUrl')}/DingBiao/ZbJgTzs/xingtai/get_hxr_rest.json`,{bdcode:data.bdcode,status:status,tzscode:data.tzscode}, (data, res) => {
                that.zbhxrlist=data.list;
            });
        },
        deleteTag:function (item) {
            this.scTags(item.hxrdwcode);
        },
        //获取候选人对应的信息
        gethxrxx:function(data){
            var that = this;
            if(this.form.bdcode===''||this.form.bdcode===null||this.form.bdcode===undefined){
                ShowMsgBox('请先选择标段')
            }else{
                if(that.form.typecode=='1'){
                    // 获取是否已经在线签章  获取文件fileguid
                    that.$get(`${this.getGetters('bidUrl')}/DingBiao/ZbJgTzs/xingtai/seal/queryFile.json`,{
                        bdcode:that.form.bdcode,
                        tbdwcode:data.hxrdwcode
                    }, (data, res) => {
                        if(data){
                            that.form.fileguid = data;
                        }
                    });
                }
                

                that.b = {dwname: '', dwcode: '', bjlx: '', zbjg: '', zbbj: '', jgdwcode: '', bzcode: '', bzname: '', jgdwname: '', jgshow: false, dwshow: false, bzshow: false };
                if (that.isdx) {
                    var a = data.length - 1;
                    if (data.length === 0) {
                        that.form.domains = [];
                        that.selectCount = data.length;
                        return;
                    }
                    if (that.selectCount > data.length) {
                        that.selectCount = data.length;
                        that.scTagsOther(data);
                        return;
                    }
                    that.selectCount = data.length;
                    this.form.zbdwname=data[a].hxrdwname;

                    that.b.dwname = data[a].hxrdwname;
                    that.b.dwcode = data[a].hxrdwcode;
                }
                else {
                    that.form.domains = [];
                    if (JSON.stringify(data)==="{}") {
                        return;
                    }
                    that.b.dwname = data.hxrdwname;
                    that.b.dwcode = data.hxrdwcode;
                }
                
                $.post(`${this.getGetters('bidUrl')}/DingBiao/ZbJgTzs/xingtai/get_zbr.json`,{tbdwcode:that.b.dwcode,bdcode:this.form.bdcode,nodekey:this.nodekey}, (data, res) => {
                    if(data.tdata.model){
                        that.form.bjlx = data.tdata.model.bjlx;
                        that.bjlx = data.tdata.model.bjlx;
                        that.b.bjlx = that.form.bjlx
                        if(that.form.bjlx==='1'){
                            that.form.zbjg = data.tdata.model.zbjg;
                            that.form.bzcode = data.tdata.model.bzcode;
                            that.form.bzname = data.tdata.model.bzname;
                            that.form.jgdwcode = data.tdata.model.jgdwcode;
                            that.form.jgdwname = data.tdata.model.jgdwname;

                            that.b.zbjg = data.tdata.model.zbjg;
                            that.b.bzcode = data.tdata.model.bzcode;
                            that.b.bzname = data.tdata.model.bzname;
                            that.b.jgdwcode = data.tdata.model.jgdwcode;
                            that.b.jgdwname = data.tdata.model.jgdwname;
                            that.form.domains.push(that.b);
                        }else{
                            that.form.zbbj = data.tdata.model.zbbj;
                            that.form.bzcode = data.tdata.model.bzcode;
                            that.form.bzname = data.tdata.model.bzname;
                            that.form.jgdwcode = data.tdata.model.jgdwcode;
                            that.form.jgdwname = data.tdata.model.jgdwname;

                            that.b.zbbj = data.tdata.model.zbbj;
                            that.b.bzcode = data.tdata.model.bzcode;
                            that.b.bzname = data.tdata.model.bzname;
                            that.b.jgdwcode = data.tdata.model.jgdwcode;
                            that.b.jgdwname = data.tdata.model.jgdwname;
                            that.form.domains.push(that.b);
                        }
                    }else {
                        if(data.tdata.kbjlmx.length>0){
                            if(that.nodekey){
                                that.assignment(data.tdata.kbjlmx[0]);
                            }else{
                                that.dialogTitle = '选择投标报价'
                                that.dialogComponent = 'choice-content';
                                that.dialogData = data.tdata.kbjlmx;
                                that.dialogShow();
                                setTimeout(() => {
                                    that.$refs.multiSelect.focus()
                                }, 50)

                            }
                            
                        }else{
                            that.form.domains.push(that.b);
                        }
                        
                    }
                    console.log(that.b,that.form.domains)
                });
            }
        },
        // 关闭回调
        dialogClose(val) {
            var that = this;
            this.dialogVisible=false;
            if(val){
                that.assignment(val)
            }else{
                this.form.aa.pop()
            }
            
            
        },
        // 赋值单元投标金额
        assignment(data){
            var that = this;
            that.form.bjlx = data.mxtype;
            that.b.bjlx = data.mxtype;
            that.nodekey = data.nodekey;
            if(data.mxtype=='1'){
                that.form.zbjg = data.nodevalue;
                that.form.bzcode = '156';
                that.form.bzname = '人民币';
                that.form.jgdwname = data.unit;
                if(data.unit=='元'){
                    that.form.jgdwcode = '1';
                    that.b.jgdwcode = '1';
                }else{
                    that.form.jgdwcode = '2';
                    that.b.jgdwcode = '2';
                }

                that.b.zbjg = data.nodevalue;
                that.b.bzcode = '156';
                that.b.bzname = '人民币';
                that.b.jgdwname = data.unit;

                that.form.domains.push(that.b);
            }else{
                that.form.zbbj = data.nodevalue;
                that.form.bzcode = '156';
                that.form.bzname = '人民币';
                that.form.jgdwname = data.unit;
                if(data.unit=='元'){
                    that.form.jgdwcode = '1';
                    that.b.jgdwcode = '1';
                }else{
                    that.form.jgdwcode = '2';
                    that.b.jgdwcode = '2';
                }

                that.b.zbbj = data.nodevalue;
                that.b.bzcode = '156';
                that.b.bzname = '人民币';
                that.b.jgdwname = data.unit;

                that.form.domains.push(that.b);
            }
        },
        //设置通知书类型
        scTags:function(dwcode){
            var that = this;
            this.form.domains.forEach(function (item, index) {
                var aa = item.dwcode.indexOf(dwcode);
                if (aa !== -1) {
                    that.form.domains.splice(index, 1);
                }
            })
        },
        scTagsOther:function(arr){
            var that = this;
            var domainsa = this.form.domains;
            that.form.domains = [];
            domainsa.forEach(function (item) {
                arr.forEach(function (a) {
                    var aa = item.dwcode.indexOf(a.hxrdwcode);
                    if (aa !== -1) {
                        that.form.domains.push(item);
                    }
                })
            })
        },
        //设置通知书类型
        settzs:function(data){
            var that = this;
            // if(that.isdx){
            //     that.form.aa = [];
            // }else{
            //     that.form.aa = '';
            // }
            if(data.diccode=='1'){
                this.isdx = false
            }else{
                this.isdx = true;
            }
            this.form.typename=data.dicname;
            this.form.typecode=data.diccode;
            
            that.form.domains = [];
        },
        // 提交
        fSave:function(id,cb){           
            this.form.shbj=id;
            cb();
            // this.yzs();
        },
        submitHandler:function(){
            var that=this
            var msg = "";
            try{
                this.form.domains.forEach(function (item) {
                    if(item.bjlx===''||item.bjlx===undefined||item.bjlx===null){
                        msg = "请选择报价类型";
                        throw new Error(msg);
                    }
                    if(item.bjlx!=='1'){
                        if(item.zbbj===''||item.zbbj===undefined||item.zbbj===null){
                            msg = "请录入中标报价";
                            throw new Error(msg);
                        }
                    }else{
                        if(item.zbjg===''||item.zbjg===undefined||item.zbjg===null){
                            msg = "请录入中标价格";
                            throw new Error(msg);
                        }
                        if(item.jgdwcode===''||item.jgdwcode===undefined||item.jgdwcode===null){
                            msg = "请选择价格单位";
                            throw new Error(msg);
                        }
                        if(item.bzcode===''||item.bzcode===undefined||item.bzcode===null){
                            msg = "请录入币种单位";
                            throw new Error(msg);
                        }
                    }
                })
            } catch (e) {
                if (msg) {
                    ShowMsg(msg,'warning')
                    return
                }
                throw e;
            }

            if(this.$route.query.tzscode===undefined){

                var url = ''
                if(that.type=='zc'){
                    url = `${this.getGetters('bidUrl')}/DingBiao/ZbJgTzs/xingtai/add2.json`
                }else{
                    url = `${this.getGetters('bidUrl')}/DingBiao/ZbJgTzs/xingtai/add.json`
                }
                this.form.domainlist = JSON.stringify(this.form.domains);
                $.post(url,this.form, (data, res) => {
                    if (data.result) {
                        ShowMsg(data.msg,'success')
                        that.$router.go(-1);
                    } else {
                        ShowMsgBox(data.msg)
                    }
                });
            }else{
                var url = ''
                if(that.type=='zc'){
                    url = `${this.getGetters('bidUrl')}/DingBiao/ZbJgTzs/xingtai/edit2.json`
                }else{
                    url = `${this.getGetters('bidUrl')}/DingBiao/ZbJgTzs/xingtai/edit.json`
                }
                this.form.domainlist = JSON.stringify(this.form.domains);
                that.$post(url,this.form, (data, res) => {
                    if (res.result) {
                        ShowMsg(res.msg,'success')
                        that.$router.go(-1);
                    } else {
                        ShowMsgBox(res.msg)
                    }
                });
            }
        },
        closedialog:function(type){
            this.dialogVisible=type;
        }
    },
    created() {
        var that=this
        if(this.$route.query.tzscode===undefined){
            that.$get(`${this.getGetters('bidUrl')}/DingBiao/ZbJgTzs/xingtai/addinit.json`,{zbprocode:this.$route.query.zbprocode}, (data, res) => {
                that.bdlist=data.bdlist;
                that.bztype=data.bztype;
                this.form.fileguid=data.fileguid;
                that.jgdw=data.jgdw;
                that.tzstype=data.tzstype;
                this.form.tzscode=data.tzscode;
            });
        
        }else{
            that.$get(`${this.getGetters('bidUrl')}/DingBiao/ZbJgTzs/xingtai/editinit.json`,{tzscode:this.$route.query.tzscode}, (data, res) => {
                var obj = {};
                obj = data.model;
                that.bdlist=data.bdlist;
                that.bztype=data.bztype;
                that.jgdw=data.jgdw;
                that.tzstype=data.tzstype;
                obj.tzscode=data.model.tzscode;
                obj.fileguid=data.fileguid;

                obj.domains=data.domains;
                obj.aa=data.model.zbdwcode;
                that.form = obj;
                console.log(that.form)
                // that.form=JSON.parse(data.zbjgtzsinfo);
                that.gethxr(that.form, '1')
            });
            that.isdx = false
        }
        that.type = that.getQuery('type')
    },
    mounted() {
        var that=this
   


    }
}
</script>

<style scoped lang="scss">
.active{
    color:#F56C6C;
    font-size:12px;
}
.oneposi{
    position: absolute;
    left:35%;
    bottom:-10px;
}
.twoposi{
    position: absolute;
    left:65%;
    bottom:-10px;
}
.thereposi{
    position: absolute;
    left:80%;
    bottom:-10px;
}
.el-dialog__wrapper{ z-index: 1000000 !important;}
</style>
